import React from 'react';
import { AreaChart, Area, ResponsiveContainer } from 'recharts';

/**
 * @param {number[]} data - array of numeric values
 * @param {string} [color='#3B82F6']
 * @param {number} [height=48]
 * @param {boolean} [filled=true]
 */
export function SparklineChart({ data = [], color = '#3B82F6', height = 48, filled = true }) {
  if (!data || data.length === 0) return null;

  const chartData = data.map((value, index) => ({ index, value: Number(value) || 0 }));

  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={chartData} margin={{ top: 2, right: 2, bottom: 2, left: 2 }}>
          <defs>
            <linearGradient id={`spark-${color.replace('#', '')}`} x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={filled ? 0.3 : 0} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <Area
            type="monotone"
            dataKey="value"
            stroke={color}
            strokeWidth={1.5}
            fill={`url(#spark-${color.replace('#', '')})`}
            dot={false}
            isAnimationActive={false}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
